import { HttpApi, HttpEndpoint, s } from "@kosmod/pancake";
import { AccountDescription, AuthTokenID } from "./account";
import { Game, GameID } from "./game";
import { Player } from "./player";
import { Invitation, InvitationDescription, InvitationID } from "./invitation";

export type LoginClient = HttpApi.Handler<"client", typeof loginAPI>;
export type LoginServerHandler = HttpApi.Handler<"server", typeof loginAPI>;
export const loginAPI = HttpApi.Branch({
  /**
   * For Account-related things relevant to your own account
   * (which is the majority of regular user's interactions with the accounts)
   * api
   */
  'accounts': HttpEndpoint.Json({
    /**
     * Creates a new account, and automatically logs
     * the current session into that account by providing a
     * login token
     */
    POST: {
      query: s.o({}),
      request: s.o({
        username: s.str,
        email: s.str,
        password: s.str,
      }),
      response: s.o({
        token: s.str,
      })
    },
    /**
     * Retrieves information about the currently
     * logged into account
     */
    GET: {
      query: s.null,
      request: s.null,
      response: s.optional(s.o({
        account: AccountDescription,
        tokenId: AuthTokenID,
      }))
    }
  }),
  'tokens': HttpApi.Branch({
    'login': HttpEndpoint.Json({
      POST: {
        query: s.o({}),
        request: s.o({
          usernameOrEmail: s.str,
          password: s.str,
        }),
        response: s.du('op', {
          'ok': { token: s.str, },
          'err': { message: s.str, }
        })
      }
    }),
    '/': HttpEndpoint.Json({
      DELETE: {
        query: s.o({}),
        request: s.o({
          tokenId: AuthTokenID,
        }),
        response: s.o({
          
        })
      }
    })
  }),
});

export type GamesClient = HttpApi.Handler<"client", typeof gamesAPI>;
export type GamesServerHandler = HttpApi.Handler<"server", typeof gamesAPI>;
export const gamesAPI = HttpApi.Branch({
  '/': HttpEndpoint.Json({
    POST: {
      query: s.null,
      request: s.o({
        name: s.str,
      }),
      response: s.o({
        game: Game
      }),
    },
    GET: {
      query: s.o({
        gameId: s.optional(GameID),
      }),
      request: s.null,
      response: s.o({
        games: s.a(Game)
      }),
    },
    UPDATE: {
      query: s.o({
        gameId: GameID,
      }),
      request: s.o({
        name: s.str,
      }),
      response: s.null,
    }
  }),
  'invitation': HttpEndpoint.Json({
    GET: {
      query: s.o({
        invitationId: s.optional(InvitationID),
        gameId: s.optional(GameID),
      }),
      request: s.null,
      response: s.o({
        invitations: s.a(InvitationDescription)
      }),
    },
    POST: {
      query: s.null,
      request: s.o({
        game: GameID,
        addressedTo: s.str,
      }),
      response: s.o({
        invitation: InvitationDescription
      }),
    }
  }, { allowHeaders: ['invitation-secret'] }), 
  'players/by-invitation': HttpEndpoint.Json({
    POST: {
      query: s.null,
      request: s.o({
        invitationId: InvitationID,
        code: s.str,
        game: GameID,
      }),
      response: s.o({
        player: Player,
      }),
    },
  }),
  'players': HttpEndpoint.Json({
    GET: {
      query: s.o({ game: GameID }),
      request: s.null,
      response: s.o({ players: s.a(Player) }),
    },
    POST: {
      query: s.null,
      request: s.o({
        name: s.str,
      }),
      response: s.o({
        game: Game
      }),
    },
  }),
  'players/me': HttpEndpoint.Json({
    GET: {
      query: s.o({ game: GameID }),
      request: s.null,
      response: s.o({
        me: Player
      }),
    }
  })
})